import * as React from 'react';
import * as styles from '../styles.css';

import { Grid, Row, Col, ArticleParagraph1 } from '@cian/ui-kit';

import { IHeaderLayoutProps } from '../types';

export const DesktopView: React.FC<IHeaderLayoutProps> = ({ headerText, subheaderText, agentCard, features }) => {
  return (
    <div data-testid="HeroResult_desktop" className={styles['layout']}>
      <div className={styles['content']}>
        <Grid>
          <Row>
            <Col xs={8}>
              <h1 className={styles['header']}>{headerText}</h1>
              <div data-testid="DesktopView-subheader" className={styles['subheader']}>
                <ArticleParagraph1 color="text-inverted-default">{subheaderText}</ArticleParagraph1>
              </div>
              <div className={styles['features']}>
                {features.map((feature, i) => (
                  <div className={styles['feature']} key={i}>
                    {feature}
                  </div>
                ))}
              </div>
            </Col>
            <Col xs={4}>{agentCard}</Col>
          </Row>
        </Grid>
      </div>
    </div>
  );
};

DesktopView.displayName = 'DesktopView';
